import { MouseEvent, useCallback, useState } from "react";

export function usePopoverTrigger() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const close = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const triggerProps = {
    onMouseDown: (e: MouseEvent<HTMLElement>) => {
      if (open) {
        e.stopPropagation();
        setAnchorEl(null);
      }
    },
    onClick: (e: MouseEvent<HTMLElement>) => {
      if (!open) {
        setAnchorEl(e.currentTarget);
      }
    }
  };

  return { anchorEl, open, triggerProps, close };
}
